import { IndexLinkProps, Link } from 'react-router';
import { Button, LinkProps } from '@mui/material';
import { F0 } from '../../helpers/types';

export type EmptyStateCTAProps = {
  caption: string;
  onClick?: F0;
} & Partial<Pick<IndexLinkProps, 'to'>>;

export const EmptyStateCTA = (p: EmptyStateCTAProps) => {
  const to = p.to || '';
  const linkProps = to.toString().startsWith('http')
    ? ({ href: to, target: '_blank' } as Pick<LinkProps, 'href' | 'target'>)
    : ({ to } as Pick<IndexLinkProps, 'to'>);

  const cs = 'px-0 text-sm underline font-normal';

  return p.onClick && !to ? (
    <Button className={cs} onClick={p.onClick}>
      {p.caption}
    </Button>
  ) : (
    // TODO: check it
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <Link className={cs} {...(linkProps as any)} onClick={p.onClick}>
      {p.caption}
    </Link>
  );
};
